exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr > td[data-v-131036a8] {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0; \n    white-space: nowrap;\n}\ntr > th[data-v-131036a8] {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0;\n    white-space: nowrap;\n}\ntr:nth-child(even) > th[data-v-131036a8] {\n    border-top: none;\n    line-height: 1em;\n}\ntr:nth-child(odd) > th[data-v-131036a8] {\n    border-bottom: none;\n}\n.shrink[data-v-131036a8] {\n    width: 1%;\n}\n", ""]);

// exports
